// import { clear } from 'console';

export default {
  emits: ["onSelected"],
  data() {
    return {
      loadingText: "processing...",
      currentSelectedIndex: -1,
      scrolltimer: null,
      showselectedState: true
    };
  },
  props: {
    //是否正在刷新
    refreshing: {
      Type: Boolean,
      default: false
    },
    //数据列表，每一条数据必须包含iconpath字段
    dataList: {
      Type: Array,
      default: []
    },
    //是否显示选中状态
    showSelected: {
      Type: Boolean,
      default: true
    },
    // 产品类型
    product_type: {
      Type: String,
      default: ""
    }
  },
  watch: {
    isdialogVisible: {
      handler: function (val, oldVal) {
        this.dialogVisible = val;
      },
      deep: true
    },
    dataList: {
      handler: function (val, oldVal) {
        if (val.length == 0) {
          this.currentSelectedIndex = -1;
          return;
        }
        // console.log(" watch dataList old length", oldVal.length, " new length ", val.length);

        if (val.length == oldVal.length) {
          // 如果长度相等，不做处理
          return;
        }
        let self = this;
        self.$nextTick(() => {
          self.invokeSelected(0, true);
        });

        // datalist 改变或加载后，也刷新到列表，这样确保当前显示的是效果图列表，并且可以点击操作
        // 2.20补充，PC端chrome，还是存在第一次加载后，不能点击的问题，尚未解决
        setTimeout(() => {
          this.$refs.switchContainer.scrollIntoView();
        }, 200); // 延迟时间为500毫秒，可以根据实际情况调整
      },

      deep: true
    },
    refreshing() {
      if (this.refreshing) {
        // 延迟滚动操作
        setTimeout(() => {
          this.$refs.switchContainer.scrollIntoView();
          // const scrollHeight = this.$refs.switchContainer.parentElement.scrollHeight;
          // window.scrollTo(0, scrollHeight);
        }, 500); // 延迟时间为500毫秒，可以根据实际情况调整
      }
    },

    showSelected() {
      // console.log(" watch showSelected ",this.showselectedState);
      this.showselectedState = this.showSelected;
    }
  },
  mounted() {
    let switchcontainelement = this.$refs.switchContainer;
    switchcontainelement.addEventListener("scroll", this.handleScroll);
  },
  methods: {
    onclickThumbnail(index) {
      // console.log("onclickThumbnail ",index);
      // // 弹出对话框，调试使用
      // window.alert("onclickThumbnail "+index);

      this.invokeSelected(index);
    },
    //触发选中
    invokeSelected(index, forced = false) {
      // console.log("invokeSelected ",index);
      // console.log("this currentselected index ", this.currentSelectedIndex, " product_type ", this.product_type);
      // console.log("forced ", forced);

      this.currentSelectedIndex = index;
      let selectedinfo = {
        product_type: this.product_type,
        data: this.dataList[index]
      };
      this.$emit("onSelected", selectedinfo);

      // currentSelectedIndex改变后，滚动到当前选中的位置
      // this.$refs.switchContainer.scrollIntoView();
    }
  }
};